var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"100vh","background":"#fff","padding":"20px"}},[_c('TemplateFeedback',{ref:"pageFeedback"}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.tnc)}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-779c69d1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Page/Admin/PageViewSeasonTerminationTnC.vue
// module id = null
// module chunks = 